import { render, staticRenderFns } from "./articlecard.vue?vue&type=template&id=1ae90d81&"
import script from "./articlecard.vue?vue&type=script&lang=js&"
export * from "./articlecard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Kirbyimage: require('/opt/build/repo/components/kirbyimage.vue').default})
